import { Autocomplete, FormControl, TextField } from '@mui/material';
import { currentOrgVar } from 'apollo/reactive-variables/organization';
import { ConnectedLab } from 'models/organization';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

type LabFilterProps = {
    onLabFilterChange: (_: React.SyntheticEvent, lab: ConnectedLab | null) => void;
    selectedLab?: ConnectedLab | null;
};

const LabFilter: FC<LabFilterProps> = ({ onLabFilterChange, selectedLab }: LabFilterProps) => {
    const { t: translate } = useTranslation(['common']);
    const org = currentOrgVar();

    return (
        <FormControl fullWidth>
            <Autocomplete
                id="lab-select"
                options={org.connectedLabs}
                value={(selectedLab || { lab: { name: '' } }) as ConnectedLab}
                getOptionLabel={(lab: ConnectedLab) => lab.lab?.name}
                isOptionEqualToValue={(option: ConnectedLab, value: ConnectedLab) => option?._id === value?._id}
                onChange={onLabFilterChange}
                renderInput={(params) => <TextField {...params} label={translate('common:LAB')} />}
            />
        </FormControl>
    );
};

export default LabFilter;
